if (!customElements.get('testimonial-slider')) {
    class TestimonialSlider extends HTMLElement {
        constructor() {
            super();
            this.resizeObserver = null;
        }

        connectedCallback() {
            this.init();
        }

        disconnectedCallback() {
            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
            }
        }

        init() {
            const carousel = this.querySelector('grid-slider');
            if (carousel) {
                this.initScrollbar(carousel);
                this.initMobileNav(carousel);
            }
        }

        initMobileNav(carousel) {
            const prevBtn = this.querySelector('[data-mobile-prev]');
            const nextBtn = this.querySelector('[data-mobile-next]');
            const wrapper = this.querySelector('.testimonials__slider-wrapper');
            
            if (nextBtn) {
                nextBtn.addEventListener('click', () => {
                    carousel.scrollBy({ left: carousel.offsetWidth * 0.8, behavior: 'smooth' });
                });
            }

            if (prevBtn) {
                prevBtn.addEventListener('click', () => {
                    carousel.scrollBy({ left: -carousel.offsetWidth * 0.8, behavior: 'smooth' });
                });
            }

            if (wrapper) {
                const checkPosition = () => {
                    const isMobile = window.innerWidth < 768;
                    if (!isMobile) return;

                    const scrollLeft = carousel.scrollLeft;
                    const maxScroll = carousel.scrollWidth - carousel.clientWidth;
                    
                    wrapper.classList.toggle('is-at-start', scrollLeft <= 5);
                    wrapper.classList.toggle('is-at-end', scrollLeft >= maxScroll - 5);
                };

                carousel.addEventListener('scroll', checkPosition, { passive: true });
                window.addEventListener('resize', checkPosition, { passive: true });
                // Running it after a small delay to ensure rendering is complete
                setTimeout(checkPosition, 100);
            }
        }

        initScrollbar(carousel) {
            // Target the newly renamed progress bar data attribute
            const fill = this.querySelector('[data-testimonial-progress-fill]');
            if (!fill) return;

            const update = () => {
                // Count visible items
                const allItems = carousel.querySelectorAll('.testimonial-card');
                const visibleItemsCount = Array.from(allItems).filter(el => el.offsetParent !== null).length || 1;
                const thumbPct = (1 / visibleItemsCount) * 100;
                fill.style.width = thumbPct + '%';

                let ratio = 0;
                const flkty = carousel.flkty || (window.Flickity && Flickity.data(carousel));

                // Flickity active (Desktop)
                if (flkty && flkty.isActive) {
                    const lastSlide = flkty.slides[flkty.slides.length - 1];
                    const maxTravel = lastSlide ? Math.abs(lastSlide.target) : 0;
                    const currentPos = Math.abs(flkty.x);
                    ratio = maxTravel > 0 ? Math.min(currentPos / maxTravel, 1) : 0;
                }
                // Native Scroll (Mobile)
                else {
                    const maxScrollLeft = carousel.scrollWidth - carousel.clientWidth;
                    if (maxScrollLeft > 0) {
                        ratio = carousel.scrollLeft / maxScrollLeft;
                        ratio = Math.max(0, Math.min(ratio, 1));
                    }
                }

                fill.style.left = (ratio * (100 - thumbPct)) + '%';
            };

            // ResizeObserver
            this.resizeObserver = new ResizeObserver(() => {
                window.requestAnimationFrame(update);
            });
            this.resizeObserver.observe(carousel);

            // Native scroll listener (mobile)
            carousel.addEventListener('scroll', () => {
                window.requestAnimationFrame(update);
            }, { passive: true });

            // Flickity listener
            const onFlickityReady = () => {
                const flkty = carousel.flkty || (window.Flickity && Flickity.data(carousel));
                if (flkty) {
                    flkty.on('scroll', () => window.requestAnimationFrame(update));
                    // Initial update
                    update();
                }
            };

            if (carousel.classList.contains('flickity-enabled')) {
                onFlickityReady();
            } else {
                const observer = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        if (mutation.target.classList.contains('flickity-enabled')) {
                            observer.disconnect();
                            onFlickityReady();
                        }
                    });
                });
                observer.observe(carousel, { attributes: true, attributeFilter: ['class'] });
            }

            // Initial update for non-flickity state
            update();
        }
    }

    customElements.define('testimonial-slider', TestimonialSlider);
}